import { render, staticRenderFns } from "./SearchResultsDesktop.vue?vue&type=template&id=00ef7144"
import script from "./SearchResultsDesktop.vue?vue&type=script&lang=js"
export * from "./SearchResultsDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports